export default __webpack_public_path__ + "static/media/logo-error.fdbd8f44.svg";